import { ConfigProvider } from 'antd';
import { routesPath } from '../../common/constants/routesPath';
import { themeConfigAuth } from '../../theming/themeConfigAuth';
import { LanguageProvider } from '../../context/LanguageProvider';
import Unsubscribe from './Unsubscribe';

// a top-level route, outside Providers and AuthGuard: the link works signed out, and must never lead to sign-in.
// Kept in its own module so a test renders exactly the entry index.js registers.
export const unsubscribeRoute = {
    path: routesPath.PUBLIC.UNSUBSCRIBE,
    element: (
        <LanguageProvider>
            <ConfigProvider theme={themeConfigAuth}>
                <Unsubscribe />
            </ConfigProvider>
        </LanguageProvider>
    ),
};
